import { environment } from "../config/environment";
import { getFromBackendAPI } from "./api.service";

export interface AuditLogEntryDto {
  id: number;
  spreadsheetId: string;
  userEmail: string;
  userName: string;
  action: string;
  entityType: string;
  entityId?: string;
  details?: Record<string, unknown>;
  createdAt: string;
}

export interface GetAuditLogOptions {
  action?: string;
  userEmail?: string;
  limit?: number;
  offset?: number;
}

/**
 * Get audit log entries for a spreadsheet
 */
export async function getAuditLog(
  spreadsheetId: string,
  options?: GetAuditLogOptions
): Promise<AuditLogEntryDto[]> {
  const params = new URLSearchParams();
  if (options?.action) params.set("action", options.action);
  if (options?.userEmail) params.set("userEmail", options.userEmail);
  if (options?.limit) params.set("limit", options.limit.toString());
  if (options?.offset) params.set("offset", options.offset.toString());

  const query = params.toString();
  const endpoint = `${environment.api.baseUrl}${environment.api.endpoints.spreadsheets}/${spreadsheetId}/audit-log${query ? `?${query}` : ""}`;
  return await getFromBackendAPI<AuditLogEntryDto[]>(endpoint);
}
